export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== "function") return;
  // Krótkie opóźnienie: Head API musi najpierw podmienić <title> nowej podstrony.
  setTimeout(() => {
    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, 50);
};

export const onClientEntry = () => {
  // Kliknięcia telefonu i e-maila, raz na cały dokument. Bez adresu e-mail w parametrach (GA4 nie przyjmuje danych osobowych).
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!a || typeof window.gtag !== "function") return;
    const isTel = a.getAttribute("href").startsWith("tel:");
    window.gtag("event", isTel ? "klikniecie_telefon" : "klikniecie_email", isTel ? { link_url: a.href } : {});
  });
};
